import React from 'react';
import './style.scss';
import { getCurrentLangText, getFormatDateTime } from '../../../lib';
import newsListBg from '../../../../src/assets/svg/news-list-bg.svg';
import { IDownloadNews } from '../../../model/api-modules/download-center';
import classNames from 'classnames';

interface IProps {
  readonly newsAllList: IDownloadNews[];
  readonly getNewsDetail: (id: number) => Promise<void>;
}

export const DownloadNewsList = (props: IProps) => {
  const renderContent = () => {
    return (
      <div className="news-list-box">
        {props.newsAllList.map((item, index) => {
          const createTime =
            getFormatDateTime(item.CreateTime).split(' ') || [];
          return (
            <div
              className={classNames(
                'news-list-item',
                index === props.newsAllList.length - 1 ? 'no-border' : ''
              )}
              onClick={() => props.getNewsDetail(item.id)}
            >
              <div className="news-list-item-title">
                {getCurrentLangText(item.Title)}
              </div>
              <div className="news-list-item-time">
                {createTime.length !== 0 ? createTime[0] : ''}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderHeaderBg = () => {
    return (
      <div className="news-list-bg-box">
        <img src={newsListBg} className="news-bg" />
      </div>
    );
  };

  return (
    <div
      className="news-list-modal"
      onClick={(event) => event.stopPropagation()}
    >
      {renderHeaderBg()}
      {renderContent()}
    </div>
  );
};
